import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type State = {
    autoTranslateNotificationLastDismissed: number | null
}

type Action = {
    setAutoTranslateNotificationLastDismissed: (
        autoTranslateNotificationLastDismissed: State['autoTranslateNotificationLastDismissed']
    ) => void
}

export const NotificationStore = create<State & Action>()(
    persist(
        set => {
            return {
                autoTranslateNotificationLastDismissed: null,
                setAutoTranslateNotificationLastDismissed: (
                    autoTranslateNotificationLastDismissed: State['autoTranslateNotificationLastDismissed']
                ) => {
                    set({ autoTranslateNotificationLastDismissed })
                },
            }
        },
        {
            name: 'notification',
        }
    )
)

export const useAutoTranslateNotificationLastDismissed = () =>
    NotificationStore(state => state.autoTranslateNotificationLastDismissed)
export const useSetAutoTranslateNotificationLastDismissed = () =>
    NotificationStore(state => state.setAutoTranslateNotificationLastDismissed)
